import { render } from "./StudentTimetableView.vue?vue&type=template&id=d1178ba2"
import script from "./StudentTimetableView.vue?vue&type=script&lang=js"
export * from "./StudentTimetableView.vue?vue&type=script&lang=js"
script.render = render

export default script